import React, { useRef, useState , useEffect,useMemo} from 'react';
import moment from 'moment';
import {
  StructuredGenerate,
  DynamicDropDownInput,
  DynamicNumericInput,
  DynamicDateInput,
  DynamicTextInput,
  DynamicCheckBoxInput,
  DynamicHiddenInput,
  DynamicButtonInput
} from '../../software-dynamic-version-2/mainSection-multiple-inputs-v-2';
import IrtizaDynamicInputGrid from '../../software-dynamic-version-2/popup-input-grid-v-2';


import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import { AutoCompleteComponent } from '@syncfusion/ej2-react-dropdowns';
import TNAService from './TNA.service';
import Moment from 'react-moment';

const TNAAdd = (props) => {
  console.log(props);

  let { DynamicDropDownInput: DropdownComponent, DynamicNumericInput: NumberComponent, DynamicDateInput: DateComponent , DynamicTextInput: TextComponent ,DynamicCheckBoxInput:CheckBoxComponent , DynamicHiddenInput : HiddenComponent , DynamicButtonInput:ButtonComponent} = { DynamicDropDownInput, DynamicNumericInput, DynamicDateInput ,DynamicTextInput , DynamicCheckBoxInput,DynamicHiddenInput,DynamicButtonInput};
  
    const [inputProps, setInputProps] = useState({
  
    CallGridDataSource:{name: 'CallGridDataSource',   value: props.isAdd == false},
    SelectRowByID:{name: 'SelectRowByID',   value: undefined},
    
    EntryID:{name: 'EntryID',   value: props.EntryID || undefined },

    EntryDate:{name: 'EntryDate',   value: props.EntryDate || 'currentDate' },
    
    CustomerOrderNo:{
      name:{id:'ExportOrderNo',value:'CustomerOrderNo'},
      caption: 'Select Customer Order No',
      value: {id: props.ExportOrderNo || undefined ,value:props.CustomerOrderNo || ''},
      dataSource: {type:'Route',route:'TNAExportOrder'},
    },
    CustomerName:{name: 'CustomerName',   value: props.CustomerName || '' ,enabled:false },
    ShipmentDate:{name: 'ShipmentDate',   value: props.ShipmentDate || 'currentDate',enabled:false },
    ExportOrderDate:{name: 'ExportOrderDate',   value: props.ExportOrderDate || 'currentDate',enabled:false },
    OrderQuantity:{name: 'OrderQuantity',   value: props.OrderQuantity || '' ,enabled:false},
    GenerateButton:{name: 'GenerateButton', caption:'Generate' ,enabled: true}
     });
// EXTRA CODE START

// EXTRA CODE END

const handleInputCreated = async (e, name) => {
  
  if(name == 'EntryDate'){
    setTimeout(() => {
      document.getElementById('EntryDate').focus()
      document.getElementById('EntryDate').select()
    }, 400);
  }
  console.log(e);
    console.log(`Input ${name} changed to ${e}`);
  };
const handleInputFocus = async (e, name) => {
    console.log(e);
    console.log(`Input ${name} focus to ${e}`);
  };
const handleInputChange = async (value, name) => {
  if(name == 'CustomerOrderNo' && value.id != undefined){
    let data = {
      ExportOrderNo : value.id,
      ToDate: inputProps.EntryDate.value || moment().format('DD-MMM-YY')
    }
    console.log(data)
    TNAService.exportOrderSummary(data).then((response)=>{
      console.log(response);
      setInputProps((prevValues) => ({
        ...prevValues,
        ['CustomerName']: {...prevValues['CustomerName'] ,value :response.data.recordset[0]?.AName || '' },
        ['ExportOrderDate']: {...prevValues['ExportOrderDate'] ,value :response.data.recordset[0]?.ExportOrderDate || props.ExportOrderDate },
        ['ShipmentDate']: {...prevValues['ShipmentDate'] ,value :response.data.recordset[0]?.ShipmentDate || props.ShipmentDate },
        ['OrderQuantity']: {...prevValues['OrderQuantity'] ,value :response.data.recordset[0]?.TotalTowelQuantity || 0 }
  
      }));
    })
}
    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };
const handleInputBlur = async  (value, name) => {
  if(name == 'ToShopName'){
    setTimeout(()=>document.getElementById('ShopTransferDetailGrid_add').click(),700)

  }
    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };
const handleInputClick = async  ( name) => {
  if(name == 'GenerateButton'){
    setInputProps((prevValues) => ({
      ...prevValues,
      ['CallGridDataSource']: {...prevValues['CallGridDataSource'] ,value :true}
     })); 
     setTimeout(() => {
      
       setInputProps((prevValues) => ({
         ...prevValues,
         ['CallGridDataSource']: {...prevValues['CallGridDataSource'] ,value :false}
        }));  
  }, 100); 
      setTimeout(()=>{
        setInputProps((prevValues) => ({
          ...prevValues,
          ['SelectRowByID'] : {...prevValues['SelectRowByID'] ,value:0}
        })) 
        setInputProps((prevValues) => ({
          ...prevValues,
          ['SelectRowByID'] : {...prevValues['SelectRowByID'] ,value:undefined}
        }))  
        
        },700)
      setTimeout(()=>{document.getElementById('TNADetailGrid_edit').click()

      },1600)
      // setTimeout(()=>document.getElementById('TNADetailGridTNADate').focus(),1000)

    }
    console.log(name);
  };
 
  let inputsList = [
    {Input: HiddenComponent ,Props: {...inputProps.EntryID, setInputProps },ColumnSize:0},

    {Input: DateComponent ,Props: {...inputProps.EntryDate, setInputProps ,onCreated:handleInputCreated}},
    {Input: DropdownComponent ,Props: {...inputProps.CustomerOrderNo, onChange:handleInputChange,setInputProps }},

    {Input: TextComponent,Props: {...inputProps.CustomerName, setInputProps }},
    {Input: DateComponent,Props: {...inputProps.ShipmentDate, setInputProps }},
    {Input: DateComponent,Props: {...inputProps.ExportOrderDate, setInputProps }},
    {Input: NumberComponent,Props: {...inputProps.OrderQuantity, setInputProps }},
    {Input: props.isAdd ==  true ? ButtonComponent :  HiddenComponent,Props: {...inputProps.GenerateButton, setInputProps , onClick:handleInputClick},ColumnSize:props.isAdd ==  true ? 4:0},

    
  ];
// Detail Section Start
// TNADescID	
// TNASection	
// TNASectionID	
// TNADescHeading	
// TNADescDetail	
// Designation	
// DesignationID


let addColumns =[
  { field:"TNADescID",headerText:'S No.',width:'90px',textAlign:'left' ,headerTextAlign:'center',other:[{allowEditing:false}]},
  
  { field:"TNASectionID",headerText:'TNA Section ID' ,width:'10px',textAlign:'left' ,headerTextAlign:'center',other:[{visible:false}]},
  { field:"TNASection",headerText:'TNA Section',width:'160px',textAlign:'left' ,headerTextAlign:'center',other:[{allowEditing:false}]},
  
  { field:"TNADescHeading",headerText:'TNA Heading',width:'180px',textAlign:'left' ,headerTextAlign:'center',other:[{allowEditing:false}]},
  
  { field:"TNADescDetail",headerText:'TNA Description',width:'180px',textAlign:'left' ,headerTextAlign:'center',other:[{allowEditing:false}]},
  
  { field:"DesignationID",headerText:'Designation ID',width:'135px',textAlign:'left' ,headerTextAlign:'center',other:[{visible:false}]},
  { field:"Designation",headerText:'Designation',width:'150px',textAlign:'left' ,headerTextAlign:'center',other:[{allowEditing:false}]},

  { field:"TNADate",headerText:'TNA Date',width:'130px',textAlign:'right' ,headerTextAlign:'center',other:[{editType:'datepickeredit'}]},
  { field:"TNAActualCompletionDate",headerText:'Actual Date',width:'130px',textAlign:'right' ,headerTextAlign:'center',other:[{editType:'datepickeredit'}]},
  
  { field:"DeviationDays",headerText:'Difference Days',width:'140px',textAlign:'right' ,headerTextAlign:'center',other:[{allowEditing:false}]},
]

const SaveButton = (GridID ,visibility)=>{
  document.querySelector(`#${GridID}Grid_dialogEdit_wrapper > .e-footer-content button.e-control.e-btn.e-lib.e-primary.e-flat`).style.visibility = `${visibility}`;
}
let storeGridDetails = []

const callGridDataSource = async (id)=>{
  console.log('iri')
  setTimeout(()=>{SaveButton(props.GridID ,'hidden')},1000)

  if(props.isAdd == true){
    let response = await TNAService.getAddTNADetailForList(id);
    console.log(response.data.recordset);
    response.data.recordset = response.data.recordset.map(item => ({
      ...item,
      TNAActualCompletionDate: null,
    }));
    console.log(response.data.recordset);
    props.sendDetails(response.data.recordset)

    storeGridDetails = response.data.recordset;
  }
  return props.isAdd == false ? TNAService.getTNADetailForList(props.ExportOrderNo) :  TNAService.getAddTNADetailForList(id)
}



useEffect(()=>{
  storeGridDetails = []
if(props.isAdd == false){
  setInputProps((prevValues) => ({
    ...prevValues,
    ['CallGridDataSource']: {...prevValues['CallGridDataSource'] ,value :false}
  }));
  setTimeout(()=>{SaveButton(props.GridID ,'visible')},1000)

}
},[])


const addActionComplete = async (grid, args ,setDataSourceState ,getListService  , selectedRow ,selectRowByID,startEdit  )=>{
    
  console.log(selectedRow)
  console.log(grid)
  if(args.requestType == 'add' || args.requestType == 'beginEdit'){
    setTimeout(()=>{SaveButton(props.GridID ,'hidden')},1000)

    setDataSourceState(prevArray => {
      console.log(prevArray);
      console.log(args.rowIndex);
      
      return prevArray
    })
    document.getElementById('TNADetailGridTNADate').focus()
    document.getElementById('TNADetailGridTNADate').select()
    if(args.requestType == 'beginEdit' && document.getElementById('TNADetailGridTNADate').value == '' ){
    document.getElementById('TNADetailGridTNADate').value = moment().format('DD/MM/YY')
    args.rowData = {...args.rowData , TNADate:moment().format('DD/MM/YY')}
    }
    document.getElementById('TNADetailGridTNAActualCompletionDate').addEventListener('blur', async (e)=>{
      console.log(`TNAActualCompletionDate changed`)
      console.log(args.form[5].value)
      console.log(args.form[6].value)
      // Define the two dates
// Get the dates from the form and parse them as moment objects
const date1 = moment(args.form[5].value, "DD/MM/YY"); // Adjust format if needed
const date2 = moment(args.form[6].value, "DD/MM/YY"); // Adjust format if needed

// Calculate the difference in days
const diffInDays = date2.diff(date1, "days"); // Use moment's diff function

// Check if the difference is positive or negative
if (diffInDays > 0) {
  console.log(`The difference is +${diffInDays} days.`);
  document.getElementById('TNADetailGridDeviationDays').value =diffInDays
  } else if (diffInDays < 0) {
  console.log(`The difference is ${diffInDays} days.`);
  document.getElementById('TNADetailGridDeviationDays').value =diffInDays
  } else {
  document.getElementById('TNADetailGridDeviationDays').value =0
  console.log("The dates are the same.");
}

console.log(e)

 setTimeout(() => document.getElementById('TNADetailGridTNAActualCompletionDate') && grid?.endEdit(), 200);

      
    })
   
  }
  
  console.log(inputProps)
    console.log(args)
  console.log(selectedRow)
  if(args.requestType == 'save' || args.requestType == 'cancel'){
    setTimeout(()=>{SaveButton(props.GridID ,'visible')},1000)
  }
  if(args.requestType == 'save'){
    
    let inputProp = {}
        setInputProps((prevValues) => {
          console.log(prevValues);
          inputProp = prevValues
          return {...prevValues
         }});
    console.log(inputProp)
  
    let gridLength = 0
if(args.action == 'edit' && props.isAdd == true){
  setDataSourceState(prevArray => {
    console.log(prevArray);
     
    gridLength = prevArray.length
    return prevArray
  })
  
  console.log(storeGridDetails);
  let gridDetails = storeGridDetails.map((response , index)=>{
    console.log(response);
    return response.TNADescSequenceID ==  args.data.TNADescSequenceID ?
     {...response,
      TNADate:moment(args.data.TNADate).format('DD-MMM-YY') ,
      TNAActualCompletionDate:args.data.TNAActualCompletionDate ? moment(args.data.TNAActualCompletionDate).format('DD-MMM-YY') : null
    }:{
      ...response,
      // TNADate:response?.TNADate  ||  moment().format('DD-MMM-YY'),
      TNAActualCompletionDate:response?.TNAActualCompletionDate ||  null 
    }
  })

  console.log(gridDetails)
  storeGridDetails = gridDetails
  props.sendDetails(
    [...gridDetails]
  )
  setTimeout(() => {
    let  rowsInd = args.rowIndex +1;
  if(rowsInd < gridLength){
   selectRowByID(rowsInd)
    startEdit() 

  }}, 500);

}
if(args.action == 'edit' && props.isAdd == false){
  setDataSourceState(prevArray => {
    console.log(prevArray);
     
    gridLength = prevArray.length
    return prevArray
  })
  let  data = {
    EntryID:inputProp.EntryID.value,	
    EntryDate:inputProp.EntryDate.value,
    ExportOrderNo:inputProp.CustomerOrderNo.value.id,
    
    //DETAIL
      TNADescID:args.data.TNADescID,
      TNADate:args.data.TNADate,
      TNAActualCompletionDate: moment(args.data.TNAActualCompletionDate).format('DD-MMM-YY'),
      TNADetailRowID: args.data.TNADetailRowID,
      params:{
    } 
}
  const response = await TNAService.updateWithDetail(data);
          console.log(response)
          // await setDataSourceState(response.data.Recordsets.recordsets[0])
          setTimeout(() => {
            let  rowsInd = args.rowIndex +1;
          if(rowsInd < gridLength){
           selectRowByID(rowsInd)
            startEdit() 
        
          }}, 500);
        
}

    console.log(inputProps)
  }
}



// Usage in your main component
const toolbarClicking =  async (grid , args , selectedRow , getListService,setDataSourceState)=>{

}

 
  return (
    <div onKeyDown={(e)=>e.stopPropagation()}>
      {/* <FirstGridComponent/> */}
      <StructuredGenerate   mainProps={props} title={`TNA ${props.isAdd == true ? `Add` : `Edit`}`} Inputs={inputsList}/>
      {/* <pre>{JSON.stringify(inputProps, null, 2)}</pre> This is to display current state for debugging */}
      <IrtizaDynamicInputGrid
        Id='TNADetail'
        
        ColumnsList={addColumns}
        GridDataSource= {[
          {
        DataSourceType:inputProps.CallGridDataSource.value ? 'Function' : 'REST',
        DataSource:  ()=>  callGridDataSource(inputProps.CustomerOrderNo.value.id) ,
        // CreateColumns: [{columnName:'TNADate',columnValue:moment().format('')}]
         }]
  }
        DefaultSortedColumnName={'TNADescID' }
      
        ListActionComplete={addActionComplete}
        ToolbarClicking={toolbarClicking}
        SelectRowByID={inputProps.SelectRowByID.value}

        //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
        AllowTemplate={false}
        ToolbarOption={['Edit','Update','Cancel']}
        AllowGrouping={false}
        AllowExcelExport={false} 
        AllowPdfExport={false} 
        ShowColumnChooser={false}
        AllowPaging={false}
        AllowDataBound={false}
        // ListSecurity={}
        // AddSecurity={'ShopTransferList'}
        EditSecurity={'TNA'}
        // DeleteSecurity={'ShopTransferList'}
        DefaultSortedColumnSort={'Ascending'}
        FilterColumns={[]} /* IT USED WHEN GIVING FILTER IN GRID LIKE IsDeleted Column or more */
        GroupColumns={[]} 
        ListDelete={[]}
        DeleteType={'hard'} 
        GridEditSettingMode={'Normal'}
        GridEditSettingHeaderTemplate={'<p></p>'}
        // GridSumColumns={[]}
        // AllowGridSum={true}
        // footerSumCaption={[{
        //   ColumnName:'TransferQty - sum',
        //   Caption:'Qty'
        // }]}
            {...props}
            ></IrtizaDynamicInputGrid>
    </div>
  );
}; 

export default TNAAdd;
